import { combineReducers } from 'redux'
import AdminData from './reducers/Admin'
import CompanyData from './reducers/Company'
import StaffData from './reducers/Staff'
import RiderData from './reducers/Riders'
import MerchantData from './reducers/Merchants'
import OrderData from './reducers/Orders'
import AuditData from './reducers/audit'
import UserData from './reducers/User'
import zoneData from './reducers/Zone'

const rootReducer = combineReducers({
  AdminData,
  CompanyData,
  StaffData,
  RiderData,
  MerchantData,
  OrderData,
  AuditData,
  UserData,
  zoneData,
})

export default rootReducer
